module.exports = __webpack_public_path__ + "img/logo-hokej.d7a5185b.png";